/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ToastConfig } from './toastConfig';
import { AppointmentSyncFailedData } from './appointmentSyncFailedData';


/**
 * WebSocket notification for appointment sync failed.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface AppointmentSyncFailedNotification { 
    /**
     * Always \'appointment.sync_failed\'
     */
    readonly type: string;
    data: AppointmentSyncFailedData;
    toast?: ToastConfig | null;
}
export const AppointmentSyncFailedNotification_type_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSyncFailedNotification_data_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSyncFailedNotification_toast_Validators: ValidatorFn[] =
    [ ];


